export const ActionTypes = {
  SET_FOLDERS: 'FOLDERS/SET',
  FETCH_ALL_FOLDERS: 'REQUEST/FOLDERS/ALL',
  FETCH_FOLDERS_ERROR: 'ERROR/FOLDERS/FETCH',
  SET_FOLDERS_ID: 'FOLDERS/SET_ID',
  FETCH_FOLDER_PROJECTS: 'REQUEST/FOLDER_PROJECTS/FETCH',
  FETCH_FOLDER_PROJECTS_ERROR: 'ERROR/FOLDER_PROJECTS/FETCH',
  CREATE_PROJECT: 'REQUEST/PROJECT/CREATE',
  CREATE_PROJECT_SUCCESS: 'SUCCESS/PROJECT/CREATE',
  CREATE_PROJECT_ERROR: 'ERROR/PROJECT/CREATE',
  ADD_FOLDERS_REQUEST: 'REQUEST/FOLDERS/ADD',
  ADD_FOLDERS_ERROR: 'ERROR/FOLDERS/ADD',
  DELETE_PROJECT: 'REQUEST/PROJECT/DELETE',
  DELETE_PROJECT_ERROR: 'ERROR/PROJECT/DELETE',
  EDIT_FOLDERS_REQUEST: 'REQUEST/FOLDERS/EDIT',
  EDIT_FOLDERS_ERROR: 'ERROR/FOLDERS/EDIT',
  REMOVE_FOLDERS_REQUEST: 'REQUEST/FOLDERS/REMOVE',
  REMOVE_FOLDERS_SUCCESS: 'SUCCESS/FOLDERS/REMOVE',
  REMOVE_FOLDERS_ERROR: 'ERROR/FOLDERS/REMOVE',
  MOVE_PROJECTS_REQUEST: 'REQUEST/PROJECTS/MOVE',
  MOVE_PROJECTS_ERROR: 'ERROR/PROJECTS/MOVE',
} as const
